import { apiClient } from '@/api/client';

export const api = apiClient;
